export default __webpack_public_path__ + "static/media/pnsv_stand_PalacioDeHierro.1e8c9536.png";